import { useEffect } from 'react';
import { useTolgee } from '@tolgee/react';

/**
 * Componente que maneja la dirección del texto (RTL/LTR) basado en el idioma seleccionado
 */
export const RTLHandler = () => {
  const tolgee = useTolgee(['language']);
  const currentLanguage = tolgee.getLanguage() || 'es';

  useEffect(() => {
    // Lista de idiomas RTL (Right-to-Left)
    const rtlLanguages = ['ar', 'he', 'fa', 'ur']; // Árabe, Hebreo, Persa, Urdu

    // Determinar si el idioma actual es RTL
    const isRTL = rtlLanguages.includes(currentLanguage);

    // Actualizar el atributo dir en el elemento html
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');

    // Actualizar el atributo lang en el elemento html para accesibilidad
    document.documentElement.setAttribute('lang', currentLanguage);

    console.log(`🌐 [RTLHandler] Idioma: ${currentLanguage}, Dirección: ${isRTL ? 'RTL' : 'LTR'}`);
  }, [currentLanguage]);

  return null; // Este componente no renderiza nada
};
